import { useMutation } from "@apollo/client";
import { UPDATE_FINANCE_TREE_TRANSACTION } from "../graphql/mutations/financeTransaction.graphql";

interface TransactionLineInput {
  financeTreeId: number;
  description?: string;
  debit?: number;
  credit?: number;
}

interface MediaInput {
  fileName: string;
  originalName: string;
  mimeType: string;
  size: number;
  type: string;
  url: string;
  isActive?: boolean;
  altText?: string;
  description?: string;
}

interface UpdateFinanceTreeTransactionDto {
  date: string;
  description: string;
  media?: MediaInput | null; // Single object, not array
  transactionLines: TransactionLineInput[];
}

interface UpdateFinanceTreeTransactionVariables {
  id: number;
  updateFinanceTreeTransactionDto: UpdateFinanceTreeTransactionDto;
}

interface Media {
  id: number;
  url: string;
  originalName: string;
  fileName: string;
  mimeType: string;
  type: string;
  size: number;
}

interface TransactionLine {
  id: number;
  financeTreeId: number;
  description?: string;
  debit?: number;
  credit?: number;
}

interface FinanceTreeTransaction {
  id: number;
  transactionNumber: string;
  date: string;
  description?: string;
  imageId?: number | null;
  totalDebit: number;
  totalCredit: number;
  total: number;
  isBalanced: boolean;
  createdAt: string;
  updatedAt: string;
  image?: Media | null;
  transactionLines: TransactionLine[];
}

interface UpdateFinanceTreeTransactionData {
  updateFinanceTreeTransaction: FinanceTreeTransaction;
}

export const useUpdateFinanceTransaction = () => {
  return useMutation<UpdateFinanceTreeTransactionData, UpdateFinanceTreeTransactionVariables>(
    UPDATE_FINANCE_TREE_TRANSACTION
  );
};

